import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button, ButtonSize } from '@cian/button-component';
import { TextField, VisualSize } from '@cian/text-field-component';
import * as React from 'react';
import { EDeviceType } from '../../types/device';
import { EActiveFlow } from '../../types/flow';
import { EAuthenticateStatus, ECheckEmailStatus } from '../../types/authentication';
import { ERegisterStatus, ERegisterErrorType } from '../../types/registration';
import { isEmail } from '../../utils/validation';
import { Context as ResponsiveContext } from '../Responsive';
import { Tooltip, ETooltipSize } from '../Tooltip';
import { RegistrationFormContainer } from './components/RegistrationForm';
import { LoginFormContainer } from './components/LoginForm';
import * as styles from './styles.css';
export var AuthenticationForm = /*#__PURE__*/function (_React$Component) {
  _inherits(AuthenticationForm, _React$Component);

  var _super = _createSuper(AuthenticationForm);

  function AuthenticationForm(props) {
    var _this;

    _classCallCheck(this, AuthenticationForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleLoginValueChange", function (login) {
      _this.setState({
        isChanged: true,
        isLoginInvalid: !!login && !isValidLogin(login)
      });

      _this.props.changeLogin(login);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitClick", function (event) {
      event.preventDefault();
      var login = _this.props.login;

      if (!login || !isValidLogin(login)) {
        return;
      }

      var _this$props = _this.props,
          checkEmail = _this$props.checkEmail,
          changeFlow = _this$props.changeFlow;

      if (isEmail(login)) {
        checkEmail();
      } else {
        changeFlow(EActiveFlow.Authentication);
      }

      _this.setState({
        isChanged: false
      });
    });

    _this.state = {
      persistent: true,
      isChanged: true,
      isLoginInvalid: !!props.login && !isValidLogin(props.login)
    };
    return _this;
  }

  _createClass(AuthenticationForm, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props2 = this.props,
          activeFlow = _this$props2.activeFlow,
          authentication = _this$props2.authentication;
      var authenticate = authentication.authenticate;
      var nextActiveFlow = nextProps.activeFlow,
          nextAuthentication = nextProps.authentication;
      var nextAuthenticate = nextAuthentication.authenticate;

      if (activeFlow !== nextActiveFlow || authentication.password !== nextAuthentication.password) {
        this.setState({
          isChanged: true
        });
      }

      if (authenticate.status !== nextAuthenticate.status) {
        this.setState({
          isChanged: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          activeFlow = _this$props3.activeFlow,
          login = _this$props3.login,
          _this$props3$authenti = _this$props3.authentication,
          _this$props3$authenti2 = _this$props3$authenti.checkEmail,
          checkEmailStatus = _this$props3$authenti2.status,
          checkEmailError = _this$props3$authenti2.error,
          _this$props3$authenti3 = _this$props3$authenti.authenticate,
          authenticateStatus = _this$props3$authenti3.status,
          authenticateError = _this$props3$authenti3.error,
          _this$props3$registra = _this$props3.registration.register,
          registerStatus = _this$props3$registra.status,
          registerErrorType = _this$props3$registra.errorType,
          registerError = _this$props3$registra.error;
      var _this$state = this.state,
          isChanged = _this$state.isChanged,
          isLoginInvalid = _this$state.isLoginInvalid;
      var isLoading = checkEmailStatus === ECheckEmailStatus.Loading || [EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus) || [ERegisterStatus.Loading, ERegisterStatus.Succeed].includes(registerStatus);
      var isError = (!activeFlow && checkEmailStatus === ECheckEmailStatus.Failed || activeFlow === EActiveFlow.Authentication && authenticateStatus === EAuthenticateStatus.Failed || activeFlow === EActiveFlow.Registration && registerStatus === ERegisterStatus.Failed && registerErrorType && registerErrorType === ERegisterErrorType.Email) && !isChanged;
      var error = !activeFlow && checkEmailError || activeFlow === EActiveFlow.Authentication && authenticateError || activeFlow === EActiveFlow.Registration && registerErrorType && [ERegisterErrorType.Common || ERegisterErrorType.Email].includes(registerErrorType) && registerError || undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, /*#__PURE__*/React.createElement("form", {
        action: "#"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['login_row']
      }, /*#__PURE__*/React.createElement(ResponsiveContext.Consumer, null, function (deviceType) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          size: ETooltipSize.M,
          content: isError ? error : '',
          hideDelay: deviceType === EDeviceType.Phone ? 3000 : undefined
        }, /*#__PURE__*/React.createElement(TextField, {
          placeholder: "Email \u0438\u043B\u0438 ID",
          name: "login",
          maxLength: 255,
          inputStyle: styles['login_input'],
          invalid: isError || isLoginInvalid,
          value: login,
          onValueChange: _this2.handleLoginValueChange,
          size: VisualSize.MEDIUM,
          disabled: isLoading
        }));
      })), !activeFlow && /*#__PURE__*/React.createElement("div", {
        className: styles['submit_row']
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        block: true,
        size: ButtonSize.M,
        isSync: isLoading,
        onClick: this.handleSubmitClick
      }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C")), activeFlow === EActiveFlow.Authentication && /*#__PURE__*/React.createElement(LoginFormContainer, null), activeFlow === EActiveFlow.Registration && /*#__PURE__*/React.createElement(RegistrationFormContainer, null)));
    }
  }]);

  return AuthenticationForm;
}(React.Component);

function isValidLogin(login) {
  return /^\d+$/.test(login) || isEmail(login);
}